import { Link, useParams } from "react-router-dom";
import { Layout } from "../components/layout/Layout";
import { ArticleCard } from "../components/posts/ArticleCard";
import { JsonLd } from "../components/seo/JsonLd";
import { SEO } from "../components/seo/SEO";
import { breadcrumbSchema, collectionPageSchema } from "../components/seo/schema";
import { site } from "../data/site";
import { getCategory } from "../lib/taxonomy";
import { NotFound } from "./NotFound";

export function CategoryPage() {
  const { slug = "" } = useParams();
  const category = getCategory(slug);

  if (!category) return <NotFound />;

  const title = `${category.name} Articles - ${site.name}`;
  const description = `Browse ${category.count} published yawiki.org articles in ${category.name}.`;
  const canonical = `${site.url}/category/${category.slug}`;

  return (
    <Layout>
      <SEO title={title} description={description} canonical={canonical} />
      <JsonLd
        data={[
          collectionPageSchema(title, description, `/category/${category.slug}`, category.posts.map((post) => post.url)),
          breadcrumbSchema([
            { name: "Home", url: "/" },
            { name: category.name, url: `/category/${category.slug}` }
          ])
        ]}
      />
      <nav className="breadcrumbs" aria-label="Breadcrumbs">
        <Link to="/">Home</Link>
        <span>/</span>
        <span>{category.name}</span>
      </nav>
      <header className="page-header">
        <p className="eyebrow">Category</p>
        <h1>{category.name}</h1>
        <p>{description}</p>
      </header>
      <div className="article-list">
        {category.posts.map((post) => (
          <ArticleCard key={post.slug} post={post} />
        ))}
      </div>
    </Layout>
  );
}
